(() => {
  "use strict";

  const rootSelector = "[data-lucia-gallery-root]";
  const gallerySelector = ".lp-shopify-gallery";
  const readyClass = "lp-shopify-js-ready";
  const fallbackClass = "lp-shopify-no-script";

  const initGallery = (gallery) => {
    if (gallery.dataset.luciaGallerySync === "true") return;

    const root = gallery.closest(rootSelector);
    const viewport = gallery.querySelector(".lp-shopify-gallery-viewport");
    const track = gallery.querySelector(".lp-shopify-slider-track, .lp-track");
    const states = [...gallery.querySelectorAll(".lp-shopify-gallery-state")];

    if (!root || !viewport || !track || states.length === 0) return;

    gallery.dataset.luciaGallerySync = "true";
    root.classList.remove(fallbackClass);
    root.classList.add(readyClass);

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let frame = 0;

    const isNativeScrollMode = () => {
      const style = window.getComputedStyle(viewport);
      return style.overflowX !== "hidden" && viewport.scrollWidth > viewport.clientWidth + 2;
    };

    const nearestIndex = () => {
      const target = Math.max(0, viewport.scrollLeft);
      let nearest = 0;

      states.forEach((unusedState, index) => {
        const card = track.children[index];
        const nearestCard = track.children[nearest];
        if (!card || !nearestCard) return;
        if (Math.abs(card.offsetLeft - target) < Math.abs(nearestCard.offsetLeft - target)) {
          nearest = index;
        }
      });

      return nearest;
    };

    const syncFromScroll = () => {
      if (!isNativeScrollMode()) return;

      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        const state = states[nearestIndex()];
        if (state && !state.checked) state.checked = true;
      });
    };

    const scrollToState = (state) => {
      if (!isNativeScrollMode()) return;

      const index = states.indexOf(state);
      const card = track.children[index];
      if (!card) return;

      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const left = Math.min(maxScroll, Math.max(0, card.offsetLeft));

      state.checked = true;
      viewport.scrollTo({
        left,
        behavior: reducedMotion.matches ? "auto" : "smooth",
      });
    };

    states.forEach((state) => {
      state.addEventListener("change", () => scrollToState(state));
    });

    gallery.addEventListener("click", (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const label = target?.closest("label[for]");
      if (!label || label.getAttribute("aria-disabled") === "true") return;

      const state = document.getElementById(label.htmlFor);
      if (!state || !states.includes(state) || !isNativeScrollMode()) return;

      const pageScrollX = window.scrollX;
      const pageScrollY = window.scrollY;
      event.preventDefault();
      event.stopPropagation();
      scrollToState(state);
      window.scrollTo({ left: pageScrollX, top: pageScrollY, behavior: "auto" });
    });

    viewport.addEventListener("scroll", syncFromScroll, { passive: true });
    window.addEventListener("resize", syncFromScroll);
    syncFromScroll();
  };

  const init = () => {
    document.querySelectorAll(`${rootSelector} ${gallerySelector}`).forEach(initGallery);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);
})();
